<template>
  <div>
    <div id="sample-size" class="row">
      <div class="col-md-12">
        Randomly select
        <el-input-number
          v-model="sampleSize"
          @change="handleSampleSizeChange"
          :min="1"
          size="mini"
          style="margin: 0 5px"
        ></el-input-number>
        profiles that fit the above criteria
      </div>
    </div>

    <div id="exclusion-period" class="row">
      <div class="col-md-12">
        Exclude profiles sampled in the last
        <el-select
          v-model="exclusionPeriod"
          style="margin: 0 5px"
          placeholder="Select"
          size="mini"
          clearable
          @change="handleExclusionChange"
        >
          <el-option
            v-for="exclusionPeriod in exclusionPeriods"
            :key="exclusionPeriod.value"
            :label="exclusionPeriod.label"
            :value="exclusionPeriod.value"
          >
          </el-option>
        </el-select>
      </div>
    </div>

    <el-alert
      v-if="insufficientProfiles"
      title="There are insufficient profiles fitting your filter criteria to draw this sample size"
      type="error"
    />
  </div>
</template>

<script>
import { get } from 'lodash';

export default {
  name: 'RandomSampleFilter',
  props: {
    sampleSize: {
      type: Number,
      default: 250,
    },
    availableProfiles: {
      type: Number,
      required: true,
    },
  },
  data: () => ({
    exclusionPeriod: null,
    exclusionPeriods: [
      { value: 1, label: '1 Month' },
      { value: 3, label: '3 Months' },
      { value: 6, label: '6 Months' },
      { value: 0, label: 'All time' },
    ],
  }),
  methods: {
    handleSampleSizeChange(value) {
      this.$emit('change-sample-size', value);
    },
    handleExclusionChange() {
      this.$emit('filter', ['meta.sampleset', this.exclusionPeriod]);
    },
    apply(filter) {
      const exclusionPeriod = get(filter, 'meta.sampleset', null);
      this.exclusionPeriod = exclusionPeriod;
    },
    reset() {
      this.exclusionPeriod = null;
      this.handleExclusionChange();
    },
  },
  computed: {
    insufficientProfiles() {
      return this.sampleSize > this.availableProfiles;
    },
  },
};
</script>

<style scoped>
#sample-size,
#exclusion-period {
  margin-top: 20px;
  margin-bottom: 30px;
}
</style>



// WEBPACK FOOTER //
// RandomSampleFilter.vue?35dd1787